import { createFeatureSelector, createSelector } from '@ngrx/store'
import { STAFF_FEATURE_KEY, StaffState, staffAdapter } from './staff.reducer'

export const selectStaffState = createFeatureSelector<StaffState>(STAFF_FEATURE_KEY)

const { selectAll, selectEntities } = staffAdapter.getSelectors()

export const selectStaffLoaded = createSelector(selectStaffState, (state: StaffState) => state.loaded)

export const selectAllStaff = createSelector(selectStaffState, (state: StaffState) => selectAll(state))

export const selectStaffEntities = createSelector(selectStaffState, (state: StaffState) => selectEntities(state))

export const selectSelectedId = createSelector(selectStaffState, (state: StaffState) => state.selectedId)

export const selectEntity = createSelector(selectStaffEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const selectExportReportLoaded = createSelector(
  selectStaffState,
  (state: StaffState) => state.exportReportLoaded,
)
